import React from 'react';
import './button.scss';

export enum ButtonType {
  PRIMARY = 'btn--main',
  SECONDARY = 'btn--secondary',
  SIMPLE = 'btn--simple'
}

interface ButtonProps {
    children: any;
    buttonId?: string;
    isSubmit?: boolean;
    isPrimary?: boolean;
    type?: ButtonType;
    onClick: (e: any) => any;
    icon?: any;
    className?: string;
    disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = (props) => (

  <button id={props.buttonId}
          type={props.isSubmit ? 'submit' : 'button'}
          className={`btn ${props.type || ButtonType.SIMPLE || ButtonType.SECONDARY} ${props.className}` }
          onClick={props.onClick}
          disabled={props.disabled}
          role='button'>
    {props.icon}
    {props.children}
  </button>
);
